// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Glutathione Initial 6/1/26 09.17.26" (f998bb0c-2eb3-4e8b-9cc8-2fdcc74dacf9). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiGlutathioneInitialQuestions = [
  {
    field: 'mdiGlutathioneInitial_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiGlutathioneInitial_pregnantBreastfeeding',
    label: 'Are you Pregnant or Breastfeeding?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'currently_pregnant', value: 'Currently Pregnant' },
        { key: 'currently_breastfeeding', value: 'Currently Breastfeeding' },
        {
          key: 'planning_to_become_pregnant_within_90_da',
          value: 'Planning to become pregnant within 90 days'
        },
        {
          key: 'not_pregnant_nor_breastfeeding',
          value: 'NOT Pregnant nor Breastfeeding'
        }
      ]
    },
    extras: { mdiQuestionId: '63f1f0de-b6ff-4feb-9991-ab0ed2e50f41' }
  },
  {
    field: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot',
    label:
      'URGENT: Due to Pregnancy or Breastfeeding, you cannot be medically qualified.',
    type: 'info',
    subLabel:
      'Please contact your customer support for alternative options.&#160;',
    answer: {
      type: 'text',
      name: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
    },
    extras: { mdiQuestionId: '9970936d-4254-4ae2-9b38-e5b32e12e2f7' }
  },
  {
    field: 'mdiGlutathioneInitial_reasonSeekingTreatmentGlutathione',
    label: 'What is the reason you are seeking treatment with glutathione?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'antioxidant_benefits', value: 'Antioxidant benefits' },
        { key: 'general_detoxification', value: 'General detoxification' },
        { key: 'liver_support', value: 'Liver support' },
        { key: 'immune_system_support', value: 'Immune system support' },
        {
          key: 'general_neurologic_health',
          value: 'General neurologic health'
        },
        { key: 'metabolic_benefits', value: 'Metabolic benefits' },
        {
          key: 'general_skin_health_and_anti_aging',
          value: 'General skin health and anti-aging'
        },
        {
          key: 'energy_support_general_recovery',
          value: 'Energy support/general recovery'
        },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'other_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '2769e967-2c57-4afd-ba3e-725ac2bf2016' }
  },
  {
    field: 'mdiGlutathioneInitial_historyKidneyDisease',
    label: 'Do you have any of the following?',
    type: 'select',
    educationalSlide:
      'If yes to any of the following, please provide as much detail for your doctor including any labs or specialist visits you have had in the past so your doctor can determine if this treatment is appropriate and safe for you.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'history_of_kidney_disease_or_prior_dialy',
          value: 'History of kidney disease or prior dialysis',
          answer: {
            type: 'text',
            name: 'history_of_kidney_disease_or_prior_dialy_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_liver_disease_or_cirrhosis',
          value: 'History of liver disease or cirrhosis',
          answer: {
            type: 'text',
            name: 'history_of_liver_disease_or_cirrhosis_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'active_cancer_or_history_of_cancer',
          value: 'Active cancer or history of cancer',
          answer: {
            type: 'text',
            name: 'active_cancer_or_history_of_cancer_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_asthma_or_chronic_lung_respir',
          value: 'History of asthma or chronic lung/respiratory disease',
          answer: {
            type: 'text',
            name: 'history_of_asthma_or_chronic_lung_respir_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'allergic_reaction_in_the_past_to_glutath',
          value:
            'Allergic reaction in the past to glutathione or any prior infusions or injectable therapies',
          answer: {
            type: 'text',
            name: 'allergic_reaction_in_the_past_to_glutath_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: 'f1f36338-d056-46b3-b2be-fff483139db1' }
  },
  {
    field: 'mdiGlutathioneInitial_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent   (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiGlutathioneInitial_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '2ef5e690-9918-4ce0-9f1d-a8f91c81e783' }
  },
  {
    field: 'mdiGlutathioneInitial_elseLikeTellDoctorWho',
    label:
      'What else would you like to tell the doctor who will be evaluating you? This is your first message to your doctor.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiGlutathioneInitial_elseLikeTellDoctorWho',
      rows: 4,
      placeholder:
        'Example: "Hi doctor, other than what I already answered I am otherwise health and excited to get started."'
    },
    extras: { mdiQuestionId: '0b473e75-7eec-4760-9830-ef63103ea294' }
  },
  {
    field: 'mdiGlutathioneInitial_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiGlutathioneInitialAnswerField = Partial<
  QuestionAnswerMap<typeof mdiGlutathioneInitialQuestions>
>;

export default mdiGlutathioneInitialQuestions;
